import React from "react";
import PropTypes from "prop-types";
import StoryCardFeaturedBig from "../../atoms/story-card-featured-big";
import StoryCardFeaturedSmall from "../../atoms/story-card-featured-small";
import styles from "./styles.m.css";
import SpecialBundleCard from "../../atoms/special-bundle-card";
import { VikatanMainResponsive } from "../ad-free";
import SmallStoryCardCurve from "../../atoms/small-story-card-curve";

const MyvikatanCollection = ({
  collection,
  accentColor,
  authorname = true,
  sectiontag = true,
  newtheme = true,
  firstcardcenter = true,
  pagetype = "",
  myvikatanstory = true,
  withoutimg = true,
  bigsizecard = true,
  myvikatanwidget = true,
  userType = ""
}) => {
  const { items } = collection;
  const limit = userType === "P" ? 7 : 5;
  return (
    <div className={`${styles["four-story-half-featured"]}`} style={accentColor && { "--accent-color": accentColor }}>
      <div className={`${styles["four-story-container"]} container`}>
        <div className={`${styles["four-story-row"]}`}>
          {items &&
            items.length > 0 &&
            items
              .slice(0, 9)
              .map(item => (
                <StoryCardFeaturedSmall
                  className={styles["story-card-featured-small"]}
                  key={item.id}
                  story={item.story}
                  sectiontag={sectiontag}
                  newtheme={newtheme}
                  firstcardcenter={firstcardcenter}
                  myvikatanstory={myvikatanstory}
                />
              ))}
        </div>
        <div>
          <div className={styles["sidebar"]}>
            <VikatanMainResponsive
              placement={pagetype}
              MobileAdtype="Vikatan_mrec_mid_SP"
              DesktopAdtype="Vikatan_Desktop_SP_ATF_Right_300x250"
            />
            <SpecialBundleCard userType={userType} limit={limit} />
            {/* <div className={styles["mano-ad"]}>
              <a href="https://www.manohartravels.com/" rel="noopener noreferrer" target="_blank">
                <img src="https://images.assettype.com/vikatan/2025-05-28/6zx47nfb/Day-2-mukthinath-300-x-600.jpg" />
              </a>
            </div> */}
          </div>
        </div>
      </div>
      <div className={`${styles["story-grid"]} container`}>
        <div className={styles["without-image-container"]}>
          {items &&
            items.length > 0 &&
            items
              .slice(9, 16)
              .map(item => (
                <StoryCardFeaturedSmall
                  className={styles["story-card-featured-small"]}
                  key={item.id}
                  story={item.story}
                  sectiontag={sectiontag}
                  newtheme={newtheme}
                  withoutimg={withoutimg}
                />
              ))}
        </div>
        <div className={styles["last-story-container"]}>
          {items &&
            items.length > 0 &&
            items.slice(16, 21).map(item => (
              <SmallStoryCardCurve
                className={styles["story-card-featured-small"]}
                key={item.id}
                story={item.story}
                sectiontag={sectiontag}
                bigsizecard={bigsizecard}
                authorname={authorname}
              />
              // <SmallStoryCardCurve
              //   className={styles["story-card-featured-small"]}
              //   key={item.id}
              //   story={item.story}
              //   sectiontag={sectiontag}
              //   bigsizecard={bigsizecard}
              // />
            ))}
        </div>
      </div>
    </div>
  );
};

MyvikatanCollection.propTypes = {
  accentColor: PropTypes.string,
  authorname: PropTypes.string,
  sectiontag: PropTypes.string,
  newtheme: PropTypes.bool,
  firstcardcenter: PropTypes.bool,
  pagetype: PropTypes.string,
  myvikatanstory: PropTypes.bool,
  withoutimg: PropTypes.bool,
  bigsizecard: PropTypes.bool,
  myvikatanwidget: PropTypes.bool,
  userType: PropTypes.string,
  collection: PropTypes.shape({
    name: PropTypes.string,
    id: PropTypes.number,
    slug: PropTypes.string,
    items: PropTypes.arrayOf(PropTypes.shape(StoryCardFeaturedBig.propTypes)),
    accentColor: PropTypes.string
  })
};

export default MyvikatanCollection;
